<template>
    <div v-if="url && ogp && ogp.title" class="embed">
        <div class="d-flex justify-content-center" v-if="ogp.image">
            <img :src="ogp.image" :alt="ogp.title" class="img-fluid">
        </div>
        <div class="body" :class="{small: small}">
            <div class="title">
                <a :href="url" target="_blank" class="stretched-link text-reset" v-html="ogp.title">
                </a>
            </div>
            <div class="description">{{$filters.truncate(ogp.description, 120)}}</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.embed {
    border: 1px solid #ccc;
    border-radius: 1rem;
    overflow: hidden;
    position: relative;
    .body {
        background-color: rgba(230, 230, 230, .2);
        padding: 1rem;
        border: 0;
        border-radius: 0;
        .title {
            font-size: 1.0rem;
        }
        .description {
            font-size: 0.8rem;
        }
        &.small {
            .title {
                font-size: .8rem;
            }
            .description {
                font-size: .7rem;
            }
        }
    }
}
</style>

<script>
export default {
    props: {
        url: {
            default: null,
        },
        small: {
            default: false,
        }
    },
    data() {
        return {
            ogp: null,
        }
    },
    methods: {
        loadOgp() {
            if (!this.url) {
                this.ogp = null;
                return;
            }
            axios.get("/ogp", {params: {
                url: this.url
            }}).then(res => {
                this.ogp = res.data;
            }).catch(err => { alert.err(err.response) });
        }
    },
    watch: {
        url(n, o) {
            this.loadOgp();
        }
    },
    mounted() {
        this.loadOgp();
    }
}
</script>